/**
 * Pulsing skeleton placeholder for notification lists. Renders `count` rows
 * (default 3) shaped like a NotificationRow.
 */
export function NotificationListSkeleton({ count = 3, compact = false }) {
  const padY = compact ? 'py-2' : 'py-3';
  return (
    <div aria-busy="true" aria-label="Loading notifications">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`flex items-start gap-3 px-3 ${padY}`}>
          <span className="mt-0.5 h-8 w-8 flex-shrink-0 animate-pulse rounded-full bg-gray-200" />
          <div className="flex-1 space-y-2">
            <div className="h-3 w-3/4 animate-pulse rounded bg-gray-200" />
            <div className="h-2.5 w-1/3 animate-pulse rounded bg-gray-100" />
          </div>
          <span className="h-2 w-2 animate-pulse rounded-full bg-gray-200" />
        </div>
      ))}
    </div>
  );
}
